export default __webpack_public_path__ + "static/media/Strifescar Gauntlets.16e5c2f2.jpg";